import login from "../../assets/images/logo/logo.png";
import loginimg from "../../assets/images/logo/login.jpg";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Spinner } from "react-bootstrap";
import { LoginSubmit, sendNotification } from "../../api/login/Login";
import CustomInputField from "../../common/CustomInputField";
import { SaveUserDeatilsLocalStorage } from "../../utils/localStorage";
import { useDispatch } from "react-redux";
import { setIsLogin } from "../../slice/auth";
import { Formik } from "formik";
import CustomPassInputField from "../../common/CustomPassInputField";
import { getToken } from "firebase/messaging";
import { messaging } from "../../firebase/fireBase";

function Login() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const [tokenNoti, setTokenNoti] = useState(null);

  const requestPermission = async () => {
    Notification.requestPermission().then((permission) => {
      if (permission === "granted") {
        getToken(messaging, { vapidKey: "BHaGFehWhqyDb8i4GmE220QoB_7TZdWtxaH8FrKIjDg3Q4kAcb0-p9cOAGhMCi4GREadlekIl1vFpX-4cM9J8Gg" })
          .then((currentToken) => {
            if (currentToken) {
              console.log("Got FCM device token:", currentToken);
              setTokenNoti(currentToken);
            } else {
              console.log("No registration token available.");
            }
          })
          .catch((err) => {
            console.log("Error retrieving token: ", err);
          });
      }
    });
  };

  useEffect(() => {
    requestPermission();
  }, []);

  const validate = (values) => {
    let errors = {};
    if (!values.email) {
      errors.email = "Email is required";
    }
    if (!values.password) {
      errors.password = "Password is required";
    }
    return errors;
  };

  const submitForm = async (values) => {
    setLoading(true);
  

    try {
      let result = await LoginSubmit(values);
      if (result.statusCode == "200") {
        setLoading(false);
        SaveUserDeatilsLocalStorage(result?.data?.token);
        dispatch(setIsLogin({ isLogin: !!result.data.token }));
        navigate("/admin", { state: result?.data?.token });
      } else {
        alert(result?.message);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      console.log("Login error:", error);
    }
    try {
      await sendNotification({ type: "Browser", token: tokenNoti });
    } catch (error) {
      console.log("Notification error:", error);
    }
  };

  return (
    <div className="authincation h-100">
      <div className="container-fluid">
        <div className="row h-100">
          <div className="col-lg-6 col-md-12 col-sm-12 mx-auto align-self-center">
            <div className="login-form">
              <div className="text-center">
                <h3 className="title">Sign In</h3>
                <p>Sign in to your account to start using Needu</p>
              </div>
              <Formik
                initialValues={{ email: "", password: "", rememberMe: false }}
                validate={validate}
                onSubmit={submitForm}
              >
                {(formik) => {
                  const { values, handleSubmit, errors, handleChange, handleBlur } = formik;
                  return (
                    <form onSubmit={handleSubmit}>
                      <div className="mb-4">
                        <CustomInputField
                          type="email"
                          placeholder="Enter Email"
                          value={values.email}
                          name="email"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          errorMsg={errors.email}
                          id="email"
                        />
                      </div>
                      <div className="mb-4 position-relative">
                        <CustomPassInputField
                          type="password"
                          placeholder="Enter Password"
                          value={values.password}
                          name="password"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          errorMsg={errors.password}
                          id="password"
                        />
                      </div>
                      <div className="form-row d-flex justify-content-between mt-4 mb-2">
                        <div className="mb-4">
                          <div className="form-check custom-checkbox mb-3">
                            <input
                              type="checkbox"
                              className="form-check-input"
                              id="customCheckBox1"
                              name="rememberMe"
                              checked={values.rememberMe}
                              onChange={handleChange}
                            />
                            <label className="form-check-label" htmlFor="customCheckBox1">
                              Remember my preference
                            </label>
                          </div>
                        </div>
                        <div className="mb-4">
                          <Link to="/forgot-password" className="btn-link text-primary">
                            Forgot Password?
                          </Link>
                        </div>
                      </div>
                      <div className="text-center">
                        <button
                          className="btn btn-primary w-100"
                          disabled={!values.password || !values.email || loading}
                        >
                          <div className="d-flex justify-content-center align-items-center">
                            <span style={{ fontSize: "1rem" }}>Sign In</span>
                            &nbsp;&nbsp;
                            {loading && <Spinner animation="border" style={{ height: "1rem", width: "1rem" }} />}
                          </div>
                        </button>
                      </div>
                    </form>
                  );
                }}
              </Formik>
            </div>
          </div>
          <div className="col-xl-6 col-lg-6">
            <div className="pages-left h-100">
              <div className="login-content">
                <a href="#">
                  <img src={login} className="mb-3 logo-dark" alt="needu Logo" />
                </a>
                <p>BankMudraa uses line charts to visualize customer-related metrics and trends over time.</p>
              </div>
              <div className="login-media text-center">
                <img src={loginimg} alt="Login Illustration" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
